// ============================================================================
// LCS - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'lcs',
  name: 'LCS',
  category: 'Dynamic Programming',
  complexity: {
    time: 'O(MN)',
    space: 'O(min(M, N))'
  },
  description: 'Longest Common Subsequence: finds the longest subsequence common to two sequences. A subsequence is a sequence that appears in the same relative order but not necessarily contiguous. Uses DP with a 2D table.'
};
